import { Save } from "@mui/icons-material";
import { Autocomplete, Box, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createCredentialApi,
  updateCredentialApi,
} from "../../api/credentials/credentialApi";
import LoadingButton from "../../elements/LoadingButton";
import { showSnackbar } from "../../redux/actions/commonAction";
import { getAllCredentials } from "../../redux/actions/credentialAction";
import { useStyles } from "./styles";

const basicFields = [
  { name: "credName", required: true, label: "Account Name" },
  { name: "accessKey", required: true, label: "Access Key", encrypt: true },
  { name: "secretKey", required: true, label: "Secret Key", encrypt: true },
  { name: "region", required: true, label: "Default Region" },
];

const gitFields = [
  { name: "gitRepoUrl", label: "Git URL" },
  { name: "gitBranchName", label: "Git Branch Name" },
  { name: "gitUsername", label: "Git User Name" },
  { name: "gitPassword", label: "Git Password", type: "password" },
];

const formFileds = [...basicFields, ...gitFields];

const ManageAccounts = ({ edit, defeaultValue = {}, onClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { allRegions } = useSelector((state) => state.common);
  const [state, setState] = useState({});
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (edit && defeaultValue) {
      setState(defeaultValue);
    }
  }, [edit, defeaultValue]);

  useEffect(() => {
    const isValidForm = basicFields.every((field) => state[field.name]);
    let validGit = true;
    if (state.gitUrl) {
      validGit = state.gitUserName && state.gitPassword;
    }
    setIsValid(isValidForm && validGit);
  }, [setIsValid, state]);

  const handleChange = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getChangedValues = (defaultState, currentState) => {
    const changedValues = {};
    for (const key in currentState) {
      if (currentState?.hasOwnProperty(key)) {
        if (
          !defaultState.hasOwnProperty(key) ||
          defaultState?.[key] !== currentState[key]
        ) {
          changedValues[key] = currentState[key];
        }
      }
    }

    return changedValues;
  };

  const handleSubmit = async () => {
    setLoading(true);
    const result = edit
      ? await updateCredentialApi(
          state?.credName,
          getChangedValues(defeaultValue, state)
        )
      : await createCredentialApi(state);
    setLoading(false);
    if (result) {
      onClose();
      dispatch(
        showSnackbar({
          message: edit ? `${state?.credName} Updated Successfully` : result,
          severity: "success",
          open: true,
        })
      );
      dispatch(getAllCredentials());
    }
  };

  return (
    <>
      <Box className={classes.container}>
        {formFileds.map((data) => {
          if (data.name === "region") {
            return (
              <Autocomplete
                fullWidth
                options={allRegions}
                defaultValue={defeaultValue?.region}
                value={state.region}
                getOptionLabel={(option) => option}
                onChange={(e, value) => {
                  handleChange("region", value);
                }}
                renderInput={(params) => (
                  <TextField {...params} margin="normal" label="Region" />
                )}
              />
            );
          }
          return (
            <TextField
              {...data}
              fullWidth
              type={edit && data?.encrypt ? "password" : data.type || "text"}
              disabled={edit && data.name === "credName"}
              margin="normal"
              value={state[data.name] || ""}
              onChange={(e) => handleChange(data.name, e.target.value)}
            />
          );
        })}
      </Box>
      <Box className={classes.footer}>
        <LoadingButton
          disabled={!isValid}
          loading={loading}
          startIcon={<Save />}
          onClick={handleSubmit}
          label={edit ? "Update" : "Save"}
        />
      </Box>
    </>
  );
};

export default ManageAccounts;
